/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2021-06-07 17:16:16
 * @LastEditors: Raoxf
 * @LastEditTime: 2022-07-04 23:16:21
 */
import Vue from "vue";
import ViewUI from "./plugin/iview";
import formCreate from "@form-create/iview4";
import App from "./App.vue";
import router from "./router";
import http from "./utils/http";
import config from "./config/config";
import "view-design/dist/styles/iview.css";
import "./assets/style/reset.less";
import "./assets/style/common.less";
import md5 from "js-md5"; //MD5加密

const host = "https://official.allijia.com/back/disk/";
Vue.prototype.host = host;

//需求所以引入
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { Tree } from "element-ui";

Vue.use(Tree);

import { statusSort } from "@utils/dataHandling";
import SearchArea from "@compoents/SearchArea.vue";
import TableArea from "@compoents/TableArea.vue";

import moment from "moment"; //日期转换
Vue.prototype.$moment = moment;

import { formatDate, yearformatDate } from "@utils/dataHandling";
Vue.prototype.formatDate = formatDate;
Vue.prototype.yearformatDate = yearformatDate;

Vue.config.productionTip = false;
/**
 * @description 全局相关注册
 */
Vue.use(ElementUI);
Vue.use(ViewUI);
Vue.use(formCreate);
Vue.use(http);

/**全局通用组件*/
Vue.component("SearchArea", SearchArea);
Vue.component("TableArea", TableArea);
Vue.prototype.$config = config;

/**顶部路由加载进度条及权限控制 */
router.beforeEach((to, from, next) => {
  Vue.prototype.$Loading.start();

  // 获取用户信息
  // let userInfo = JSON.parse(window.localStorage.getItem("userInfo") || "{}");

  // // 如果用户是服务商（有 companyId），只能访问订单相关页面
  // if (userInfo.companyId) {
  //   const allowedRoutes = ["/orderlist", "/orderdetail", "/login"];
  //   const toPath = to.path.toLowerCase();

  //   // 检查是否在允许的路由列表中
  //   const isAllowed = allowedRoutes.some(
  //     (route) => toPath === route || toPath.startsWith(route + "/")
  //   );

  //   if (!isAllowed && toPath !== "/login") {
  //     // 如果不是允许的路由，重定向到订单列表
  //     Vue.prototype.$Loading.finish();
  //     next("/orderlist");
  //     return;
  //   }
  // }

  next();
});

router.afterEach((routers) => {
  Vue.prototype.$Loading.finish();
});

Vue.filter("dateFmt", (input, formatString = "YYYY-MM-DD") => {
  //es5函数参数设置默认值
  //const lastFormatString = formatString || ''

  // moment(input) 把时间字符串转成时间对象
  // format(formatString) 把时间对象，按照指定格式，格式化成符合条件的字符串
  return moment(input).format(formatString);
});

/**全局mixin**/
Vue.mixin({
  methods: {
    reset() {
      this.$refs["searchData"].resetFields();
      this.search();
    },
    statusSort: statusSort,
  },
});

let userInfo = JSON.parse(window.localStorage.getItem("userInfo") || "{}");
window.userInfo = userInfo;
window.md5 = md5;
window.host = host;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
